<ng-container *ngIf="{
  azzurroHubDataProperties: azzurroHubDataProperties$ | async,
  connectionProperties: connectionProperties$ | async,
} as resolver">

  <ng-container *ngIf="deviceId$ | async as deviceId; else skeletonView">
    <lib-block-title
      id="azzurro-hub-title"
      [title]="labels.title">
    </lib-block-title>
    <lib-block-title
      id="azzurro-hub-devices-title"
      [title]="labels.devicesTitle">
    </lib-block-title>
    <lib-azzurro-hub-rescan
      id="rescan-devices-button"
      [deviceId]="deviceId"
      [labels]="{
        startRescan: labels.startRescan,
        rescanningMessage: labels.rescanningMessage,
        rescanDisclaimerTitle: labels.rescanDisclaimerTitle,
        rescanDisclaimerText: labels.rescanDisclaimerText
      }"
      [canRescan]="(canRescan$ | async) || false">
    </lib-azzurro-hub-rescan>
    <section
      id="product-image"
      class="fx-col fx-gap-2 py-2 fx-align-center fx-justify-start radius-4 block-bg-contrast">
      <div
        *ngIf="resolver.connectionProperties?.length"
        class="fx-row radius-4 border-1 fx-align-center fx-gap-3 fx-justify-between p-3 w-full"
        [ngClass]="{
          'bg-green-100 border-green-400': isConnected$ | async,
          'bg-red-100 border-red-400': !(isConnected$ | async)
        }">
        <div
          *ngFor="let property of resolver.connectionProperties"
          class="w-full">
          <div
            *ngIf="property.name === labels.connection"
            class="w-full fx-row fx-align-center fx-gap-3">

            <div class="fx-row fx-align-center fx-gap-2">
              <mat-icon [ngClass]="property.iconCssClasses">
                {{ property.icon ?? 'info' }}
              </mat-icon>
              <div class="tw-text-sm tw-font-medium text-grey-300">
                {{ property.name | titlecase }}
              </div>
            </div>

            <div class="tw-text-base tw-font-normal text-grey-400 ml-auto">
              {{ property.value | titlecase }}
            </div>

          </div>
        </div>
      </div>

      <div class="fx-col fx-center fx-g-1">
        <img
          class="h-20"
          src="blocks-assets/images/productImages/monitoring/azzurro-hub.svg">
        <span class="tw-font-medium tw-text-sm text-grey-400">
          {{ 'Azzurro Hub' | titlecase }}
        </span>
        <span class="ellipsed tw-font-normal tw-text-base text-grey-400">
          {{ deviceId }}
        </span>
      </div>
    </section>

    <ng-container *ngIf="isUpdatingFw$.value === false; else spinner">
      <ng-container *ngIf="azzurroHubDataProperties$ | async as properties">
        <section
          *ngIf="properties.length > 0"
          id="product-details">
          <div
            *ngFor="let property of properties"
            class="fx-row radius-4 block-bg-contrast fx-align-center fx-gap-3 fx-justify-between p-3">
            <mat-icon [ngClass]="property.iconCssClasses">
              {{ property.icon ?? 'info' }}
            </mat-icon>
            <div class="tw-text-sm tw-font-medium text-grey-300">
              {{ property.name | titlecase }}
            </div>
            <div
              class="tw-text-base tw-font-normal text-grey-400 ml-auto"
              [ngClass]="property.cssClasses">
              {{ property.value | titlecase }}
            </div>
          </div>
        </section>
      </ng-container>
    </ng-container>

    <ng-template #spinner>
      <div
        id="product-details"
        class="fx-col fx-center block-bg-contrast s-full">
        <mat-spinner [diameter]="24"></mat-spinner>
      </div>
    </ng-template>
  </ng-container>
</ng-container>

<azzurro-table
  id="azzurro-device-table"
  mode="client"
  [data$]="devices$"
  [columns]="columns"
  [rowExpansionTemplateByRow]="deviceRowExpansionByRow"
  [rowExpansionKey]="deviceRowKey"
  [expandAllByDefault]="true"
  [showRowExpansionIcon]="true"
  [allowRowClickExpansion]="true">
</azzurro-table>

<ng-template #skeletonView>
  <lib-block-title
    *ngIf="uiFramework === 'material'"
    id="azzurro-hub-title"
    [title]="labels.title">
    <ion-skeleton-text
      animated="true"
      class="h-6 w-32">
    </ion-skeleton-text>
  </lib-block-title>
  <div
    id="product-image"
    class="fx-col fx-gap-2 py-2 fx-center radius-4 block-bg-contrast">
    <ion-skeleton-text
      animated="true"
      class="h-20 w-20">
    </ion-skeleton-text>
    <ion-skeleton-text
      animated="true"
      class="h-5 w-32">
    </ion-skeleton-text>
    <ion-skeleton-text
      animated="true"
      class="h-5 w-24">
    </ion-skeleton-text>
  </div>
  <section id="product-details">
    <div
      *ngFor="let i of [].constructor(6)"
      class="fx-row radius-4 block-bg-contrast fx-align-center fx-gap-3 fx-justify-between p-3">
      <ion-skeleton-text
        animated="true"
        class="h-6 w-6">
      </ion-skeleton-text>
      <ion-skeleton-text
        animated="true"
        class="h-5 w-24">
      </ion-skeleton-text>
      <ion-skeleton-text
        animated="true"
        class="h-5 w-24 ml-auto">
      </ion-skeleton-text>
    </div>
  </section>
</ng-template>
<ng-template
  #actionsTemplate
  let-row>
  <mat-icon
    class="pointer"
    (click)="onDeviceSelected.emit(row.device.id)">
    remove_red_eye
  </mat-icon>
</ng-template>

<ng-template
  #psc100ExpansionTemplate
  let-row>
  <div class="fx-col fx-gap-2 p-2 pl-8">
    <azzurro-table
      tableId="psc100-inverters-table"
      mode="client"
      [data$]="getPcsInverters$(row)"
      [columns]="pcsInvertersColumns"
      [showRowExpansionIcon]="false"
      [allowRowClickExpansion]="false">
    </azzurro-table>
  </div>
</ng-template>

<ng-template
  #psc100ActionsTemplate
  let-row>
  <mat-icon
    class="pointer"
    (click)="onDeviceSelected.emit(row.sn)">
    remove_red_eye
  </mat-icon>
</ng-template>
